import { jwtDecode, JwtPayload } from "jwt-decode";

interface DecodedToken extends JwtPayload {
  role_id?: number;
  sub?: string;
}

export const getRoleId = (token: unknown): number | null => {
  if (!token || typeof token !== "string") return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.role_id !== undefined ? Number(decoded.role_id) : null;
  } catch {
    return null;
  }
};

export const getTokenExpiration = (token: unknown): Date | null => {
  if (!token || typeof token !== "string") return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.exp ? new Date(decoded.exp * 1000) : null;
  } catch {
    return null;
  }
};

export const getUsername = (token: unknown): string | null => {
  if (!token || typeof token !== "string") return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.sub || null;
  } catch {
    return null;
  }
};